var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiverAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4C6AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.919 15a3 3 0 100-6 3 3 0 000 6zm-2.8 1a3.2 3.2 0 00-3.2 3.2v2a.8.8 0 00.8.8h10.4a.8.8 0 00.8-.8v-2a3.2 3.2 0 00-3.2-3.2h-5.6z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.419 14.599a3 3 0 100-5.197 2.999 2.999 0 010 5.197zm3.7 7.401h3a.8.8 0 00.8-.8v-2a3.2 3.2 0 00-3.2-3.2h-3a3.2 3.2 0 013.2 3.2v2a.8.8 0 01-.8.8z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/receiver_avatar.bbec7ff1.svg";
export { SvgReceiverAvatar as ReactComponent };